import React from 'react'
import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'

// ファーストビュー
export const firstViewItemWhite = {
  breadcrumb: '全3回のUX/UIワークショップで、プロジェクトを前に進める共通言語を獲得',
  title1: <>全3回のUX/UIワークショップで、プロジェクトを前に進める共通言語を獲得</>,
  company: '株式会社JTBビジネストラベルソリューションズ',
  introduction_text: (
    <>
      システム開発におけるUX/UIの重要性は理解しているものの、知見をどう取り入れ、関係者とどう合意を形成するかが見えてこない。そんな課題に対して、Aitriaは、同社が使用する業務システムを題材に、UX/UIの基礎からステークホルダーマネジメント、プロジェクト憲章の策定までを段階的に扱う全3回のワークショップを設計・実施しました。
    </>
  ),
  tag1text: 'UX/UI改善',
  tag1src: '/cases/uxui-improvement/',
  industryTagText: 'サービス',
  industryTagSrc: '/cases/service/',
  image: '/images/img/cases/jtb-cwt/mv.webp',
  movie: '',
  alt: '株式会社JTBビジネストラベルソリューションズ 全3回のUX/UIワークショップで、プロジェクトを前に進める共通言語を獲得',
}

// プロジェクト概要
export const overviewTitle = '業務システムを題材にしたワークショップで、UX/UIの知見とプロジェクト推進力を獲得'

export const overviewItem: OverviewItems[] = [
  {
    text: '株式会社JTBビジネストラベルソリューションズでは、システムにとってのUX/UIの重要性を認識しつつも、社内にUX/UIの専門人材がおらず、開発においては深く考慮するのが難しい状況だったといいます。',
  },
  {
    text: 'Aitriaは、同社が使用する業務システムを題材に、UX/UIの基礎知識から関係者との合意形成、プロジェクトマネジメントまでを一貫して扱う全3回のワークショッププログラムを設計・実施。IT企画、経営企画、営業企画、コールセンターなど多様な部門から集まった参加者が、UX/UIについての基礎を学び、実務に活かすための土台を築きました。',
  },
  {
    text: '今回は、JTBビジネストラベルソリューションズの河野さん・前田さん、Aitriaの平・菅原の4名に、ワークショップの背景と成果を伺いました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'UX/UIの専門人材が不在',
        text: 'UX/UIを深く学ぶ機会の確保が難しく、社内のプロジェクトにおいて根拠に基づいたデザインの判断ができていなかった。',
      },
      {
        title: 'ステークホルダー間での合意形成の難航',
        text: '1つのプロジェクトに対する関係者が多いため、それぞれの立場に応じた意見を事前に想定して動くことが難しかった。',
      },
      {
        title: '想定外の事象に対する明確な指標の不足',
        text: 'プロジェクトにおいて想定外の事象が起きたときに立ち返る原則や、リスクを防ぐための対応策が定まっていなかった。',
      },
    ],
    solutions: [
      {
        title: '実際の業務システムを題材にした実践型プログラム',
        text: '座学による知識提供にとどまらず、参加者が普段使う画面のUX/UIを自分たちで診断・評価する構成で、学びを実務に直結させた。',
      },
      {
        title: 'プロジェクトで必要となるコミュニケーションのあり方を整理するワーク',
        text: 'ステークホルダーマップとサービスブループリントを使ったワークで、他部門や外部の立場や動きと業務の流れの理解を促した。',
      },
      {
        title: '憲章の策定によるプロジェクトの根幹の明文化',
        text: 'プロジェクトマネジメントをする際の、各々が大切に考えることを明文化することで、課題が発生した場合も全員で改めて認識を揃えられるようにした。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: (
    <>
      学びが実務を変える。
      <br />
      「UX/UIの考え方」を組織に根づかせるワークショップ。
    </>
  ),
  description: (
    <>
      UX/UIの基礎知識から、プロジェクト推進に必要な合意形成・リスクマネジメントまで。デザイナーだけでなく、プロジェクトに関わるすべての方を対象に、実務に活きるプログラムを提供します。
    </>
  ),
}
